import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-background"></div>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            ⭐ Authorized Sales Partner
          </div>
          
          <h1 className="hero-title">
            Door-to-Door Excellence for<br />
            Telecommunications Leaders
          </h1>
          
          <p className="hero-description">
            We generate qualified sales for AT&T, Spectrum, Frontier, and more. 
            Your brand, our proven field marketing expertise.
          </p>
          
          <div className="hero-stats">
            <div className="stat">
              <strong>3K+</strong>
              <span>Sales This Year</span>
            </div>
            <div className="stat">
              <strong>8+</strong>
              <span>Partner Brands</span>
            </div>
            <div className="stat">
              <strong>98%</strong>
              <span>Satisfaction Rate</span>
            </div>
          </div>
          
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">Schedule Free Consultation</Link>
            <Link to="/results" className="btn btn-secondary">See Our Results</Link>
          </div>
          
          <div className="trusted-by">
            <span className="trusted-label">Trusted by</span>
            <div className="trusted-text">
              AT&T • Spectrum • Frontier • DirecTV • Optimum • Vivint • Rise • Kinetic
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
